import { StyledSnackbarContentContainer } from './StyledSnackbarContentContainer';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { forwardRef } from 'react';
import { StyledSnackbarContent } from './StyledSnackbarContent';
import { StyledMessage } from './StyledMessage';
import { StyledTypeIcon } from './StyledTypeIcon';
import { SnackbarButtons } from './SnackbarButtons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SnackbarContent = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    message,
    type,
    className,
    action,
    id,
    ...rest
  } = _ref;
  const theme = useInterstateTheme();
  return /*#__PURE__*/_jsxs(StyledSnackbarContentContainer, {
    theme: theme,
    ...rest,
    className: 'ids-snackbar-content-container',
    id: id ? `snackbar-container-${id}` : `snackbar-container-id`,
    "data-testid": rest[`data-testid`] ? `snackbar-container-${rest['data-testid']}` : `snackbar-container-data-testid`,
    children: [/*#__PURE__*/_jsxs(StyledSnackbarContent, {
      ...rest,
      className: 'ids-snackbar-content',
      id: id ? `snackbar-content-${id}` : `snackbar-content-id`,
      "data-testid": rest[`data-testid`] ? `snackbar-content-${rest['data-testid']}` : `snackbar-content-data-testid`,
      children: [type && type !== 'default' ? /*#__PURE__*/_jsx(StyledTypeIcon, {
        type: type
      }) : null, /*#__PURE__*/_jsx(StyledMessage, {
        message: message
      })]
    }), /*#__PURE__*/_jsx(SnackbarButtons, {
      action: action,
      id: id,
      ...rest
    })]
  });
});
SnackbarContent.displayName = 'SnackbarContent';